import React from 'react';

export function Card({ children, className = '', padding = 'p-5', hover = false }) {
  return (
    <div
      className={[
        'rounded-2xl border border-zinc-200/90 bg-white shadow-md shadow-zinc-900/5 transition-shadow duration-200',
        hover && 'hover:shadow-lg hover:shadow-zinc-900/8',
        padding,
        className
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </div>
  );
}
